<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container >
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="班级" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag
                placeholder="请选择班级"
                v-model="model.classId"
                dict="school_class,name,id,delete_flag=0"
                :async="false"
                style="width: 100%"
                @change="handlerClass"
              ></j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="学生" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                show-search
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="'111'"
                v-model="model.studentId"
                placeholder="请选择学生"
                @search="handleStudentSearch"
                allowClear
              >
                <a-select-option v-for="d in studentData" :key="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="家长" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                show-search
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                v-model="model.parentId"
                placeholder="请选择家长"
                @search="handleUserSearch"
                @change="handleUserChange"
                allowClear
              >
                <a-select-option v-for="d in userData" :key="d.id">
                  {{ d.realname }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="学生关系" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                ref="relation"
                type="list"
                v-decorator="['relationCode']"
                :trigger-change="true"
                dictCode="relation"
                placeholder="请选择学生关系"
                @change="changeRelation"
              ></j-dict-select-tag>
            </a-form-item>
          </a-col>

        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from '@/components/dict/JDictSelectTag'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import Vue from "vue";
  import {TENANT_ID} from "@/store/mutation-types";

  export default {
    name: 'TeacherInfoForm',
    components: {
      JFormContainer,
      JSearchSelectTag,
      JDictSelectTag,
      JDate,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        userData: [],
        studentData: [],
        searchStudentByClassId: "student_info,name,id",
        url: {
          add: "/studentRelation/studentRelation/add",
          edit: "/studentRelation/studentRelation/edit",
          queryById: "/studentRelation/studentRelation/queryById"
        }
      }
    },
    created () {

    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'parentId','studentId','relationCode','classId','parentId_dictText','studentId_dictText'))
        })
        this.handleUserSearch("", this.model);
        this.handleStudentSearch("", this.model);
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      /**
       * 查询老师
       * @param val
       * @param name
       */
      handleUserSearch(val, initData){
        getAction("/sys/user/list", {'realname': '*'+val+'*','userIdentity_FindInSet': '4','relTenantIds_FindInSet':Number(Vue.ls.get(TENANT_ID))}).then(res => {
          this.userData = res.result.records
          if(initData.parentId){
            this.userData.push({"id": initData.parentId, "realname": initData.parentId_dictText})
          }
        })
      },
      /**
       * 选择老师
       * @param value
       */
      handleUserChange(val) {
        this.userData.forEach(item => {
          if(item.id === val){
            this.model.teacherName = item.realname;

          }
        })
      },
      /**
       * 选择学生关系
       */
      changeRelation(val){
        this.$refs['relation'].dictOptions.forEach(item => {
          if(item.value === val){
            this.model.relation = item.text;
            this.model.relationName = item.text;
          }
        })
      },
      /**
       * 选择班级
       */
      handlerClass(val){
        this.searchStudentByClassId += ",classId="+val;
        console.log(this.searchStudentByClassId)
        getAction("/aigoes/studentInfo/list", {'classId': val}).then(res => {
          this.studentData = res.result.records
        })
      },
      /**
       * 选择学生
       */
      handleStudentSearch(val, initData){
        getAction("/aigoes/studentInfo/list", {'classId': this.model.classId, 'name': '*'+val+'*'}).then(res => {
          this.studentData = res.result.records
          if(initData.studentId){
            this.studentData.push({"id": initData.studentId, "name": initData.studentId_dictText})
          }
        })
      }
    }
  }
</script>